<template>
  <div class="rt-toolbar plat-toolbar">
    <slot></slot>
    <template v-if="showBack || showAutoback">
      <div class="rt-divider"></div>
      <el-button type="text" @click="handleBackClick">返回</el-button>
    </template>
  </div>
</template>
<script>
export default {
  name: 'RtToolbar',
  props: {
    showBack: {
      type: Boolean,
      default: false,
      required: false
    },
    showAutoback: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    handleBackClick() {
      if (this.showAutoback) {
        this.$router.back();
      } else {
        this.$emit('goback');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// .rt-toolbar.plat-toolbar {
//   display: flex;
//   align-items: center;
//   .rt-divider {
//     width: 1px;
//     background-color: #ccc;
//     display: inline-block;
//     height: 14px;
//     margin: 0 15px;
//   }
//   .el-button {
//     display: inline-block;
//     line-height: 1;
//     white-space: nowrap;
//     margin: 0;
//     cursor: pointer;
//     background: #fff;
//     color: #4e5969;
//     text-align: center;
//     box-sizing: border-box;
//     outline: none;
//     transition: 0.1s;
//     font-weight: 400;
//     padding: 5px 0;
//     font-size: 14px;
//     border-radius: 2px;
//     margin-right: 8px;
//   }
// }
</style>



// WEBPACK FOOTER //
// main.vue?9e84c932